import { useQuery } from '@tanstack/react-query';
import { inventoryService } from '@/services';
import { InventoryListParams } from '@/types';
import { queryKeys } from '@/services/query-keys';
import { retryUnlessMissingState, useRefetchStatesOnMissingState } from './missing-state';

/** Stable query key so same params don't create duplicate requests (e.g. under React Strict Mode). */
const serializedParamsKey = (params?: Omit<InventoryListParams, 'limit' | 'offset'>): string =>
  params ? JSON.stringify(params) : '';

export const useInventoryCount = (
  params?: Omit<InventoryListParams, 'limit' | 'offset'>, 
  enabled: boolean = true
) => {
  const refetchStatesOnMissing = useRefetchStatesOnMissingState();
  return useQuery({
    queryKey: [...queryKeys.inventory.all, 'count', serializedParamsKey(params)],
    queryFn: () => refetchStatesOnMissing(() => inventoryService.getInventoryCount(params)),
    retry: retryUnlessMissingState,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: enabled && params?.state !== undefined,
  });
};

